/* tslint:disable */
/* eslint-disable */
/**
 * Swipe4Work Employer API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the StartMatchCommandDto interface.
 */
export function instanceOfStartMatchCommandDto(value) {
    if (!('jobApplicationId' in value) || value['jobApplicationId'] === undefined)
        return false;
    if (!('message' in value) || value['message'] === undefined)
        return false;
    return true;
}
export function StartMatchCommandDtoFromJSON(json) {
    return StartMatchCommandDtoFromJSONTyped(json, false);
}
export function StartMatchCommandDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'jobApplicationId': json['jobApplicationId'],
        'message': json['message'],
    };
}
export function StartMatchCommandDtoToJSON(json) {
    return StartMatchCommandDtoToJSONTyped(json, false);
}
export function StartMatchCommandDtoToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'jobApplicationId': value['jobApplicationId'],
        'message': value['message'],
    };
}
